import store from '../store/store';

function clearApp() {
	store.commit('forgotPassword/CLEAR_NEW_PASSWORD_STATE');
	store.commit('login/CLEAR_LOGIN_STATE');
}

export default clearApp;
